import { OfferLightLabel } from "@Common/OfferLight";
import { isLightOffer, getLightOfferCover } from "@Common/OfferLight/helpers.js";
import "../../Default/ListItem/style.scss";
import "./style.scss";
import { useState } from "react";

const ListItem = ({ handleClick = () => {}, id = "", type = false, typeLabel = "", title = "", cover = "", item }) => {
    const [openDisclaimer, setOpenDisclaimer] = useState(false);
    const showOfferLight = isLightOffer(item);

    return (
        <div className={`ab-4409-v4 list-item ${type ? type : ""} ${showOfferLight ? "offer-light" : ""} ${type === "special" ? "offer-special" : ""}`} id={id} onClick={handleClick}>
            <div className="list-item__logo">
                <img alt={`logo_desktop`} className={`logo_desktop`} src={getLightOfferCover(item, cover)} />
            </div>
            <div className="list-item__title-container">
                <span className={`list-item__title`} dangerouslySetInnerHTML={{ __html: title }}></span>
            </div>
            {showOfferLight ? <OfferLightLabel /> : type === "hit" ? <span className="ab-4409-progress" aria-hidden="true" /> : type === "special" ? <span className="list-item__hit-label_block special">{typeLabel}</span> : null}
            {item.disclaimer ? (
                <div className={`list-item__btn btn disclaimer`} onMouseEnter={() => setOpenDisclaimer(!openDisclaimer)} onMouseLeave={() => setOpenDisclaimer(!openDisclaimer)}>
                    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.668 25.6666C20.2954 25.6666 25.668 20.294 25.668 13.6666C25.668 7.03921 20.2954 1.66663 13.668 1.66663C7.04055 1.66663 1.66797 7.03921 1.66797 13.6666C1.66797 20.294 7.04055 25.6666 13.668 25.6666Z"
                            stroke="#B1BAD4"
                            strokeWidth="1.77333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M13.668 18.4666V13.6666M13.668 8.86658H13.68" stroke="#B1BAD4" strokeWidth="1.77333" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    {openDisclaimer && (
                        <div className="disclaimer__block">
                            <span>{item.offerDetail.ordRisPromo}</span>
                            <span dangerouslySetInnerHTML={{ __html: item.disclaimer }}></span>
                        </div>
                    )}
                </div>
            ) : (
                <div className={`list-item__btn btn`}>
                    <svg id="svg" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M16 28V16M16 9.33333H10.6C6.90668 9.33333 6.68002 4 10.6 4C14.8 4 16 9.33333 16 9.33333ZM16 9.33333H21.4C25.2614 9.33333 25.2614 4 21.4 4C17.2 4 16 9.33333 16 9.33333Z"
                            stroke={"#B1BAD4"}
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M26.6667 16.0002V25.3335C26.6667 26.0407 26.3857 26.719 25.8856 27.2191C25.3855 27.7192 24.7072 28.0002 24 28.0002H8C7.29276 28.0002 6.61448 27.7192 6.11438 27.2191C5.61428 26.719 5.33333 26.0407 5.33333 25.3335V16.0002M28 16.0002V12.0002C28 11.2929 27.719 10.6146 27.219 10.1145C26.7189 9.61445 26.0406 9.3335 25.3333 9.3335H6.66667C5.95942 9.3335 5.28115 9.61445 4.78105 10.1145C4.28095 10.6146 4 11.2929 4 12.0002V16.0002H28Z"
                            stroke={"#B1BAD4"}
                            strokeWidth="1.33333"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            )}
        </div>
    );
};

export default ListItem;
